import React from "react";
import { useStaticQuery, graphql } from "gatsby";

import GuildLineSteps from "./GuildLineSteps";

import "./style.scss";

const GuildLine = ({ title, description, imgs, steps }) => {
  const firstStep = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "images/create-account.svg" }) {
        publicURL
      }
    }
  `);

  const imgSteps = [firstStep.file.publicURL, ...imgs];

  return (
    <div className="content-template guild-line container">
      <div className="header text-center">
        <h2 dangerouslySetInnerHTML={{ __html: title }} />
        {description && (
          <div
            className="excerpt mt-4"
            dangerouslySetInnerHTML={{
              __html: description,
            }}
          />
        )}
      </div>
      <GuildLineSteps imgs={imgSteps} steps={steps} />
    </div>
  );
};

export default GuildLine;
